import { configureStore } from '@reduxjs/toolkit';
import authReducer from './auth/admin';
import breadcrumbReducer from './breadcrumbs';
import unsavedChangesReducer from './unsavedChanges';

export const makeStore = () => {
  return configureStore({
    reducer: {
      auth: authReducer,
      breadcrumbs: breadcrumbReducer,
      unsavedChanges: unsavedChangesReducer,
    },
  });
};

// Infer the type of makeStore
export type AppStore = ReturnType<typeof makeStore>;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];
